import { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Globe, Smartphone, Megaphone, ShoppingCart, Database, Sparkles, Briefcase, Boxes, Code2, PhoneOutgoing, Headphones, Check, ArrowRight, ArrowLeft, MessageSquarePlus, ClipboardCheck, Cpu } from "lucide-react";
import { SERVICES } from "../lib/constants";
import Reveal from "../components/Reveal";
import InquiryModal from "../components/InquiryModal";
import { Toaster } from "sonner";

const ICONS = { Globe, Smartphone, Megaphone, ShoppingCart, Database, Sparkles, Briefcase, Boxes, Code2, PhoneOutgoing, Headphones };

const ACCENTS = {
  web: "#FF6B1A", mobile: "#3B82F6", marketing: "#FFAA33", ecommerce: "#FF6B1A",
  crm: "#3B82F6", ai: "#FFAA33", consult: "#3B82F6", block: "#FF6B1A",
  custom: "#3B82F6", telesales: "#FFAA33", support: "#FF6B1A",
};

// 3-4 work-relevant photos per service for the inline gallery
const SERVICE_GALLERIES = {
  web: [
    "https://images.unsplash.com/photo-1547658719-da2b51169166?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1593720219276-0b1eacd0aef4?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1200&q=80",
  ],
  mobile: [
    "https://images.unsplash.com/photo-1551650975-87deedd944c3?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1526045478516-99145907023c?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1605170439002-90845e8c0137?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&w=1200&q=80",
  ],
  marketing: [
    "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1533750349088-cd871a92f312?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1611926653458-09294b3142bf?auto=format&fit=crop&w=1200&q=80",
  ],
  ecommerce: [
    "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1556761223-4c4282c73f77?auto=format&fit=crop&w=1200&q=80",
  ],
  crm: [
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=80",
  ],
  ai: [
    "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1655720828018-edd2daec9349?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1633613286848-e6f43bbafb8d?auto=format&fit=crop&w=1200&q=80",
  ],
  consult: [
    "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1552581234-26160f608093?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=1200&q=80",
  ],
  block: [
    "https://images.unsplash.com/photo-1639762681485-074b7f938ba0?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1518544866330-95a2bec01dc3?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1622630998477-20aa696ecb05?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1639322537228-f710d846310a?auto=format&fit=crop&w=1200&q=80",
  ],
  custom: [
    "https://images.unsplash.com/photo-1542831371-29b0f74f9713?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=80",
  ],
  telesales: [
    "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1573497019418-b400bb3ab074?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1200&q=80",
  ],
  support: [
    "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1556745753-b2904692b3cd?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?auto=format&fit=crop&w=1200&q=80",
    "https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&w=1200&q=80",
  ],
};

export default function ServiceDetail() {
  const { key } = useParams();
  const [inquiryOpen, setInquiryOpen] = useState(false);
  const service = SERVICES.find((s) => s.key === key);

  if (!service) {
    return (
      <div className="pt-40 text-center">
        <p className="text-zinc-400">Service not found.</p>
        <Link to="/services" className="text-[#FF6B1A] mt-4 inline-block">← Back to services</Link>
      </div>
    );
  }

  const Icon = ICONS[service.icon] || Sparkles;
  const accent = ACCENTS[service.key] || "#FF6B1A";
  const gallery = SERVICE_GALLERIES[service.key] || [];

  return (
    <div data-testid={`service-detail-${service.key}`}>
      <Toaster position="top-center" theme="dark" />
      {/* HERO */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img src={service.image} alt="" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 mesh-bg opacity-90" />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#09090B]/60 to-[#09090B]" />
          <div className="orb orb-flame w-[500px] h-[500px] -top-32 -left-32 opacity-30" />
          <div className="orb orb-azure w-[600px] h-[600px] top-1/3 -right-40 opacity-30" />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
          <Reveal>
            <Link to="/services" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-zinc-400 hover:text-[#FF6B1A]">
              <ArrowLeft size={14} /> All services
            </Link>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-6 inline-flex items-center gap-3">
              <span className="w-14 h-14 rounded-2xl flex items-center justify-center" style={{ background: `linear-gradient(135deg, ${accent}33, transparent)`, border: `1px solid ${accent}66` }}>
                <Icon size={24} style={{ color: accent }} />
              </span>
              <span className="text-xs font-bold uppercase tracking-[0.25em]" style={{ color: accent }}>Service</span>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <h1 className="mt-5 text-5xl sm:text-6xl lg:text-7xl font-bold leading-[1.05] max-w-4xl">{service.title}</h1>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="mt-7 max-w-2xl text-xl text-zinc-300 leading-relaxed">{service.long}</p>
          </Reveal>
          <Reveal delay={0.4}>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => setInquiryOpen(true)}
                data-testid="service-detail-quote-btn"
                className="px-8 py-3.5 rounded-full font-semibold text-black inline-flex items-center justify-center gap-2"
                style={{ background: `linear-gradient(135deg, ${accent}, #FFAA33, #3B82F6)` }}
              >
                <MessageSquarePlus size={16} /> Get a quote
              </button>
              <a href={`https://wa.me/916291074147?text=${encodeURIComponent(`Hi, I'd like to discuss ${service.title}.`)}`} target="_blank" rel="noreferrer" className="px-8 py-3.5 rounded-full border border-white/20 hover:bg-white/5">WhatsApp us</a>
            </div>
          </Reveal>
        </div>
      </section>

      {/* DELIVERABLES + HIGHLIGHTS */}
      <section className="py-20 bg-[#0b0b0d]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-12">
          <Reveal>
            <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.25em] uppercase" style={{ color: accent }}>
              <ClipboardCheck size={14} /> What we deliver
            </span>
            <h2 className="mt-3 text-3xl sm:text-4xl font-bold">Outcomes, not just <span className="fb-text">deliverables</span>.</h2>
            <ul className="mt-8 space-y-3">
              {service.deliverables.map((d) => (
                <li key={d} className="flex items-start gap-3 glass rounded-2xl px-5 py-4">
                  <span className="mt-1 w-5 h-5 rounded-full flex items-center justify-center shrink-0" style={{ background: `${accent}22`, border: `1px solid ${accent}66` }}>
                    <Check size={12} style={{ color: accent }} />
                  </span>
                  <span className="text-sm">{d}</span>
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.1}>
            <span className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.25em] text-[#3B82F6] uppercase">
              <Cpu size={14} /> Our tech stack
            </span>
            <h3 className="mt-3 text-3xl sm:text-4xl font-bold">Battle-tested <span className="azure-text">tools</span>.</h3>
            <div className="mt-8 flex flex-wrap gap-2.5">
              {service.tech.map((t) => (
                <span key={t} className="px-4 py-2 rounded-full bg-white/5 border border-white/10 text-sm text-zinc-200 hover:border-[#3B82F6]/40 transition-colors">{t}</span>
              ))}
            </div>
            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-3">
              {service.bullets.map((b, i) => (
                <motion.div key={b} whileHover={{ y: -4 }} className="glass rounded-2xl p-5 text-center">
                  <p className="text-xs uppercase tracking-[0.2em] text-[#FFAA33] font-bold">0{i + 1}</p>
                  <p className="text-sm mt-2 text-zinc-200">{b}</p>
                </motion.div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* WORK GALLERY */}
      {gallery.length > 0 && (
        <section className="py-20" data-testid="service-gallery">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <Reveal><span className="text-xs font-bold tracking-[0.25em] uppercase" style={{ color: accent }}>Selected work</span></Reveal>
            <Reveal delay={0.1}><h2 className="mt-3 text-3xl sm:text-4xl font-bold">A glimpse of what we <span className="fb-text">build</span>.</h2></Reveal>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
              {gallery.map((src, i) => (
                <Reveal key={src} delay={i * 0.05}>
                  <motion.div whileHover={{ y: -6, scale: 1.02 }} className={`relative rounded-3xl overflow-hidden border border-white/10 group ${i === 0 ? "md:col-span-2 md:row-span-2 aspect-square" : "aspect-square"}`}>
                    <img src={src} alt={`${service.title} work ${i + 1}`} loading="lazy" className="w-full h-full object-cover opacity-75 group-hover:opacity-100 group-hover:scale-110 transition-all duration-700" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                    <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between gap-2">
                      <span className="text-[10px] font-bold uppercase tracking-[0.2em] px-2.5 py-1 rounded-full bg-black/60 border border-white/15 text-zinc-200">Project {i + 1}</span>
                      <span className="w-7 h-7 rounded-full flex items-center justify-center" style={{ background: `${accent}22`, border: `1px solid ${accent}66`, color: accent }}>
                        <ArrowRight size={12} />
                      </span>
                    </div>
                  </motion.div>
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* PROCESS recap */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <Reveal><span className="text-xs font-bold tracking-[0.25em] text-[#3B82F6] uppercase">How we work</span></Reveal>
          <Reveal delay={0.1}><h2 className="mt-3 text-3xl sm:text-4xl font-bold">A simple, <span className="azure-text">battle-tested</span> process.</h2></Reveal>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mt-10">
            {[
              { n: "01", t: "Discover", d: "Free 30-min call to map goals." },
              { n: "02", t: "Design", d: "Wireframes & system design." },
              { n: "03", t: "Build", d: "Weekly demos, code reviews." },
              { n: "04", t: "Launch", d: "Go-live with monitoring." },
              { n: "05", t: "Grow", d: "Ongoing optimisation & support." },
            ].map((p) => (
              <Reveal key={p.n}>
                <motion.div whileHover={{ y: -6 }} className="glass rounded-2xl p-6 h-full relative overflow-hidden">
                  <span className="absolute -top-2 -right-1 text-7xl font-bold opacity-10 fb-text">{p.n}</span>
                  <p className="text-xs font-bold tracking-[0.25em] uppercase" style={{ color: accent }}>{p.n}</p>
                  <h3 className="mt-2 text-lg font-semibold">{p.t}</h3>
                  <p className="text-sm text-zinc-400 mt-2 leading-relaxed">{p.d}</p>
                </motion.div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <Reveal>
            <div className="gradient-border">
              <div className="rounded-3xl p-10 sm:p-14 text-center relative overflow-hidden">
                <div className="absolute -top-32 -right-32 orb orb-flame w-[400px] h-[400px] opacity-30" />
                <h2 className="relative text-3xl sm:text-4xl lg:text-5xl font-bold">Ready to start <span className="fb-text">{service.title}</span>?</h2>
                <p className="relative text-zinc-400 mt-3 max-w-xl mx-auto">Tell us about your project and we'll send a tailored quote within 24 hours.</p>
                <div className="relative flex flex-col sm:flex-row gap-3 justify-center mt-7">
                  <button onClick={() => setInquiryOpen(true)} className="px-8 py-3.5 rounded-full font-semibold text-black inline-flex items-center justify-center gap-2"
                    style={{ background: `linear-gradient(135deg, ${accent}, #FFAA33, #3B82F6)` }}
                    data-testid="service-detail-cta-quote"
                  >
                    <MessageSquarePlus size={16} /> Get a quote <ArrowRight size={16} />
                  </button>
                  <Link to="/services" className="px-8 py-3.5 rounded-full border border-white/20 hover:bg-white/5">All services</Link>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <InquiryModal
        open={inquiryOpen}
        onClose={() => setInquiryOpen(false)}
        type="service"
        itemKey={service.key}
        itemLabel={service.title}
        accent={accent}
      />
    </div>
  );
}
